export const Global = 1;
export const Country = 2;
export const SubnationalLevel1 = 3;
export const SubnationalLevel2 = 4;
export const SubnationalLevel3 = 16; // health_districts
export const Region = 6;
export const SuperRegion = 7;
export const NonSovereign = 8;

export const isLocationTypeGlobal = (location_type_id: number) =>
    [Global].includes(location_type_id);

export const isLocationTypeCountryOrSubnational = (location_type_id: number) =>
    [Country, SubnationalLevel1, SubnationalLevel2, SubnationalLevel3].includes(location_type_id);

export const isLocationTypeSubnational = (location_type_id: number) =>
    [SubnationalLevel1, SubnationalLevel2, SubnationalLevel3].includes(location_type_id);
